import React from 'react';
import { IIconProps } from './utils';

export const Drag = ({
  fill = 'currentColor',
  height = 30,
  width = 30,
  ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 30 30"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M18.125 15L26.25 15M26.25 15L23.1389 12.5M26.25 15L23.1389 17.5"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
    <path
      d="M15 11.875L15 3.75M15 3.75L12.5 6.86111M15 3.75L17.5 6.86111"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
    <path
      d="M11.875 15L3.75 15M3.75 15L6.86111 17.5M3.75 15L6.86111 12.5"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
    <path
      d="M15 18.125L15 26.25M15 26.25L17.5 23.1389M15 26.25L12.5 23.1389"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />

  </svg>
);
